import React, {Component} from 'react';
import AccordionPanel from './AccordionPanel';
import Stamp from './Stamp';
import { Accordion } from '@salesforce/design-system-react';

const CALENDAR = [
  { id: '19',
    date: 'Tues, Nov 19',
    sessions: [
      {title: 'Accessibility: Good for Users, Good for Business',
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BJNhQAO'},
      {title: 'Be An Accessibility Ally: Build Accessibility into Your Org and Training', 
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BJLcQAO'},
      {title: 'Email Best Practices for Design and Code to Improve Usability and Accessibility', 
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BKq6QAG', addition: true},
      {title: 'How Bitty & Beau\'s Coffee Built a Business Based on Inclusion (1)',
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BJe2QAG'},
      {title: 'Best Practices for Empowering Employees with Disabilities Using Salesforce',
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BKlSQAW'}
    ]
  },
  { id: '20',
    date: 'Weds, Nov 20',
    sessions: [
      {title: 'How Bitty & Beau\'s Coffee Built a Business Based on Inclusion',
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BKGpQAO'},
      {title: 'Salesforce for All: Building Accessible Apps with Lightning Web Components (1)', 
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BJNfQAO'},
      {title: '10 Accessibility Tips from Guide Dogs for the Blind',
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BKljQAG', addition: true},
      {title: 'Keyboard Navigation: Where Productivity Meets Accessibility', 
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BJNgQAO'},
      {title: 'Accessibility & Disability Trailblazers and Allies Meet & Greet (1)', 
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BL0IQAW', addition: true},
      {title: 'Accessibility & Disability Trailblazers and Allies Meet & Greet (2)', 
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BL0JQAW', addition: true},
    ]
  },
  { id: '21',
    date: 'Thurs, Nov 21',
    sessions: [
      {title: 'How Bitty & Beau\'s Coffee Built a Business Based on Inclusion (2)',
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BJePQAW'},
      {title: 'Salesforce for All: Building Accessible Apps with Lightning Web Components (2)', 
       url: 'https://success.salesforce.com/sessions?eventId=a1Q3A000021ea1UUAQ#/session/a2q3A000002BJOYQA4'},
    ]
  }
];

class App extends Component {
  constructor(props) {
    super(props);

    let today = new Date();
    let currentDate = today.getDate();

    // Pre-DF: Auto-expand all dates
    if (currentDate < 19) {
      this.state = {
        expanded19: true,
        expanded20: true,
        expanded21: true
      };

    // During DF: Auto-expand current date  
    } else {
      this.state = {
        expanded19: currentDate === 19,
        expanded20: currentDate === 20,
        expanded21: currentDate === 21,
      };
    }
  }

  render() {
    return (
      <div className="App">
        <header className="wood-texture slds-p-around_medium">
          <h1 className="splash-heading text--tan">
            <span className="splash-h1">Accessibility Journey</span>
            <span className="splash-h2">at Dreamforce</span>
          </h1>
          <div className="slds-media slds-media_large slds-media_responsive slds-p-around_medium text--white astro">
            <div className="slds-media__figure">
              <img src="assets/astro-plushie.png" alt="Astro in a wheelchair plushie" title="Astro in a wheelchair plushie" />
            </div>
            <div className="slds-media__body">
              <p className="slds-text-longform slds-p-vertical_medium">
                At Salesforce, we’re committed to building a more equal world, which includes{' '}
                building products that are accessible. We welcome you to join us on this path{' '}
                by taking part in our Accessibility Journey at DF19 and take home a{' '}
                limited-edition Astro plushie!
              </p>
              <p className="slds-text-longform">
                Did you know that <strong>1 in 5</strong> people in the U.S. have a disability?{' '}
                A disability can be temporary, permanent, situational, visible, or invisible.{' '}
                Many of us will experience a disability at some point in our lives and benefit{' '}
                from accessibility.
              </p>
            </div>
          </div>
        </header>

        <main>
          <section aria-labelledby="h_instructions" className="slds-p-top_large slds-p-horizontal_large slds-p-bottom_medium">
            <h2 id="h_instructions" className="slds-text-heading_medium text--blue text--bold slds-p-vertical_small">How to Redeem Your Prize</h2>
            <ol className="slds-list_ordered">
              <li className="slds-p-top_small">Pick up a paper Accessibility Journey card in the Accessibility Area (by Bitty & Beau's Coffee) in the Sales, Service, and Small Business Essentials Lodge in the Marriott Marquis Golden Gate Ballroom.</li>
              <li className="slds-p-top_small">Complete each of the activities below and snap photos to document your progress.</li>
              <li className="slds-p-top_small">When you've completed an activity, show your activity photo to a Dreamforce staffer in the Accessibility Area, and they'll add a stamp to your Accessibility Journey card.</li>
              <li className="slds-p-top_small">Present your completed stamp card to a Dreamforce staffer in the Accessibility Area, and they'll give you an Accessibility Journey redemption card.</li>
              <li className="slds-p-top_small">Go to the "Configure a Character" station and use the code on the redemption card to collect your limited-edition Astro plushie!</li>
            </ol>
          </section>

          <section aria-labelledby="h_stamps">
            <h2 id="h_stamps" className="slds-text-heading_small text--blue text--bold  slds-p-around_large">
              Collect four stamps to complete your journey:
            </h2>
      
            <div className="stamps">
              <Stamp index="1" heading='Explore How To Design for Inclusivity at Camp Design'>
                <h4 className="text--bold">What to do:</h4>
                <ul className="slds-list_dotted slds-p-vertical_small">
                  <li>Visit the "Design for Everyone" booth within Camp Design</li>
                  <li>Write an accessibility commitment for our pledge tree</li>
                  <li>Snap a photo with your commitment leaf</li>
                </ul>
                
                <h4 className="text--bold slds-p-top_small">Location:</h4>
                <p>Design for Everyone booth<br/>Camp Design, Trailhead area<br/>Moscone West, Floor 1</p>
              </Stamp>

              <Stamp index="2" heading='Learn About Accessibility'>
                <h4 className="text--bold">What to do:</h4>
                <p>Attend one (or more!) accessibility-related session and snap a photo while you're there.</p>

                <h4 className="text--bold slds-p-top_small">Sessions:</h4>
                <p className="text--italic">All links open session details in a new tab</p>

                <Accordion>
                  {CALENDAR.map((day, i) => (
                    <AccordionPanel
                      ariaLevel={5}
                      key={`day${i}`}
                      expanded={this.state['expanded' + day.id]} 
                      id={`day${i}`}
                      onTogglePanel={() => { this.setState({['expanded' + day.id]: !this.state['expanded' + day.id]})}}
                      summary={day.date}
                    >
                      <ul className="slds-list_dotted">
                        {day.sessions.map((session, j) => {return (
                          <li key={`day${i}-session${j}`}>
                            <a href={session.url} target="_blank">{session.title}</a>
                          </li>
                         );})}
                      </ul>
                    </AccordionPanel>
                  ))}
                </Accordion>
              </Stamp>

              <Stamp index="3" heading='Earn the "Get Started with Web Accessibility" Trail Badge'>
                <h4 className="text--bold">What to do:</h4>
                <p>Complete the following modules to earn this badge:</p>
                <ul className="slds-list_dotted slds-p-vertical_small">
                  <li><a href="https://trailhead.salesforce.com/content/learn/modules/accessibility-basics?trail_id=get-started-with-web-accessibility">Accessibility Basics</a></li>
                  <li><a href="https://trailhead.salesforce.com/content/learn/modules/designing-for-web-accessibility?trail_id=get-started-with-web-accessibility">Designing for Web Accessibility</a></li>
                  <li><a href="https://trailhead.salesforce.com/content/learn/modules/coding-for-web-accessibility?trail_id=get-started-with-web-accessibility">Coding for Web Accessibility</a></li>
                  <li><a href="https://trailhead.salesforce.com/content/learn/modules/testing-for-web-accessibility?trail_id=get-started-with-web-accessibility">Testing for Web Accessibility</a></li>
                </ul>
                <p>
                  Take a screenshot of your completed badge!
                </p>
                <h4 className="text--bold slds-p-top_small">Get started:</h4>
                <a href="https://sfdc.co/a11y-trail">sfdc.co/a11y-trail</a>
              </Stamp>

              <Stamp index="4" heading='Build an Inclusive Business'>
                <h4 className="text--bold">What to do:</h4>
                <p>Snap a photo of your commitment to accessibility at the Lego mural!</p>
                <h4 className="text--bold slds-p-top_small">Location:</h4>
                <p>Accessibility Area by Bitty & Beau’s Coffee<br/>Marriott Marquis, Golden Gate Ballroom</p>
              </Stamp>
            </div>
          </section>
        </main>

        <footer className="wood-texture slds-p-around_medium slds-text-align_center text--tan">
          <p>Short URL for this page: <a className="text--tan text--bold" href="https://sfdc.co/a11y-journey">sfdc.co/a11y-journey</a></p>
          <p className="slds-text-longform slds-p-top_medium"><a className="text--tan text--bold" href="https://www.salesforce.com/dreamforce/accessibility/">Learn more about Dreamforce Accessibility</a></p>
        </footer>
      </div>
    );
  }
}

export default App;
